export default {
  // navMenuItems Words
  dashboard: 'داشبورد',

  logout: 'خروج',

  global: {
    unlimited: 'نامحدود',
    confirm: 'تایید',
    cancel: 'انصراف'
  },

  // navbar actions
  navbar: {
    back: 'بازگشت',
    save: 'ذخیره'
  },

  // alert
  alert: {
    unsavedChanges: 'شما تغییراتی دارید که ذخیره نشده است, آیا مطمئنید که می خواهید خارج شوید؟',
    copy: 'متن کپی شد!',
    duplicateRequest: {
      title: 'هشدار',
      message: 'درخواست قبلی شما در حال پردازش است، لطفا منتظر بمانید'
    },
    error: {
      title: 'خطا',
      accessDenied: 'شما دسترسی به این فعالیت ندارید',
      openingBalanceUnlock: 'اول دوره باز است لطفا ابتدا اول دوره را قفل کنید',
      contactSupport: 'با پشتبانی تماس بگیرید',
      print: 'درخواست پرینت با خطا شد'
    },
    warning: {
      title: 'هشدار',
      repeatedRequestText: 'درخواست قبلی شما در حال پردازش است، لطفا منتظر بمانید'
    },
    message: {
      title: 'پیغام',
      pleaseWait: 'درخواست ارسال شد. لطفا منتظر بمانید...',
      saveChange: 'تغییرات ذخیره شد'
    }
  },

  // login page
  login: {
    title: 'ورود',

    getPhoneNumberStepMessage1: 'لطفا ایمیل خود را وارد کنید. رمز پیامکی ',
    getPhoneNumberStepMessage2: '(کد پنج رقمی)',
    getPhoneNumberStepMessage3: ' برای تایید ایمیل شما ارسال خواهد شد.',
    phoneNumber: 'شماره همراه',
    email: 'ایمیل',
    phoneNumberIsNotValid: 'ایمیل به صورت صحیح وارد نشده است',
    phoneNumberIsNull: 'ایمیل وارد نشده است',

    otpCodeSentStepMessage1: 'برای ',
    otpCodeSentStepMessage2: ' یک کد ۵ رقمی ارسال شد. لطفا کد را وارد کنید',
    otpCodeIsNotValid: 'کد اعتبارسنجی به صورت صحیح وارد نشده است',
    otpCodeIsNull: 'کد اعتبارسنجی وارد نشده است',
    retrieveTheCode: 'دریافت مجدد کد',

    loginToPanel: 'سامانه مدیریت منابع انسانی شرکت {name}',
    resendOTPMessage: 'برای دریافت مجدد کد یکی از روش های زیر را انتخاب کنید',
    otpCall: 'تا لحظاتی دیگر تماس با شماره {number} برقرار خواهد شد',
    resendOTPTypes: {
      resend: 'ارسال مجدد',
      sms: 'پیامک',
      tel: 'تماس'
    },

    otp: 'یکبار رمز',
    otpSend: 'کد اعتبارسنجی به {number} ارسال شد',

    getSuperAdminTokenStepMessage: 'لطفا توکن خود را وارد کنید.',
    token: 'توکن مدیر سامانه',

    buttons: {
      getOTPCode: 'دریافت کد',
      login: 'ورود'
    },

    notification: {
      userNotFound: 'کاربری با این شماره پیدا نشد!',
      accessError: 'دسترسی شما به سامانه مسدود شده است!',

      login: {
        title: 'پیغام',
        message: 'شما با موفقیت وارد سامانه شدید'
      },

      logout: {
        title: 'پیغام',
        message: 'شما با موفقیت از سامانه خارج شدید'
      },

      forceLogout: {
        title: 'پیغام',
        message: 'به علت عدم استفاده طولانی مدت از سامانه ,دوباره وارد شوید'
      }
    }
  },

  profile: {
    title: 'پروفایل',

    edit: {
      title: 'ویرایش پروفایل'
    }
  },

  // users page
  users: {
    general: {
      labels: {
        name: 'نام',
        family: 'نام خانوادگی',
        email: 'ایمیل',
        role: 'دسترسی',
        totalTime: 'ساعت کاری',
        user: 'گیرنده'
      },

      notifications: {
        insert: {
          success: 'همکار با موفقیت ایجاد شد',
          error: 'ایجاد همکار با خطا همراه شد'
        },
        edit: {
          success: 'همکار با موفقیت ویرایش شد',
          error: 'ویرایش همکار با خطا همراه شد'
        },
        delete: {
          success: 'اطلاعات همکار با موفقیت حذف شد',
          error: 'حذف اطلاعات همکار با خطا همراه شد'
        },
        restore: {
          success: 'اطلاعات همکار با موفقیت بازگردانی شد',
          error: 'بازگردانی اطلاعات همکار با خطا همراه شد'
        }
      },
      confirmations: {
        delete: {
          title: 'تاییدیه حذف همکار',
          body: 'آیا از حذف {name} اطمینان دارید؟'
        }
      }
    },

    list: {
      title: 'لیست کارکنان',

      table: {
        header: {
          row: 'ردیف',
          name: 'نام',
          email: 'ایمیل',
          totalTime: 'ساعت کاری',
          restore: 'بازگردانی',
          delete: 'حذف'
        }
      }
    },

    trash: {
      title: 'لیست همکاران حذف شده'
    },

    insert: {
      title: 'افزودن همکار'
    },

    edit: {
      title: 'ویرایش همکار'
    },

    profile: {
      title: 'پروفایل شخص',

      actions: {
        whatsApp: 'واتساپ',
        call: 'تماس'
      }
    }
  },

  // tasks page
  tasks: {
    general: {
      labels: {
        category: 'دسته بندی',
        description: 'توضیحات',
        attachment: 'پیوست',
        startTime: 'زمان شروع',
        endTime: 'زمان پایان',
        acceptedTime: 'زمان تایید شده',
        hour: 'ساعت'
      },

      notification: {
        insert: {
          success: 'تسک با موفقیت ایجاد شد',
          error: 'ایجاد تسک با خطا همراه شد'
        },
        edit: {
          success: 'تسک با موفقیت بروزرسانی شد',
          error: 'بروزرسانی تسک با خطا همراه شد'
        },
        accept: {
          success: 'تسک با موفقیت تایید شد',
          error: 'تایید تسک با خطا همراه شد'
        }
      }
    },

    list: {
      title: 'لیست تسک ها',

      table: {
        header: {
          row: 'ردیف',
          user: 'کاربر',
          startTime: 'زمان شروع',
          endTime: 'زمان پایان',
          description: 'توضیحات',
          category: 'دسته بندی',
          time: 'مدت زمان'
        }
      }
    },

    insert: {
      title: 'افزودن تسک جدید'
    },

    edit: {
      title: 'ویرایش تسک'
    },

    accept: {
      title: 'تایید تسک'
    }
  },

  tickets: {
    menu: 'تیکت ها',
    title: 'تیکت ها',

    general: {
      statusTypes: {
        all: 'همه',
        created: 'ایجاد شده',
        portalResponse: 'پاسخ اپراتور',
        appResponse: 'پاسخ کاربر',
        pending: 'در حال بررسی',
        completed: 'تکمیل شده',
        canceled: 'کنسل شده'
      },

      sendStatusTypes: {
        send: 'ارسال شده',
        notSend: 'ارسال نشده'
      },

      seenStatusTypes: {
        seen: 'مشاهده شده',
        notSeen: 'مشاهده نشده'
      },

      labels: {
        all: 'همه',
        selectType: 'موضوع رو انتخاب کنید',
        service: 'سرویس',
        responder: 'دریافت کننده',
        subject: 'موضوع تیکت',
        message: 'پیام',
        dynamicAttach: 'پیوست {number}',
        insertAttach: 'پیوست جدید',
        unknown: 'سیستمی',
        operator: 'اپراتور'
      },

      placeholder: {
        subject: 'موضوع تیکت خود را وارد کنید',
        message: 'متن پیام خود را وارد کنید'
      },

      table: {
        header: {
          row: 'ردیف',
          department: 'دپارتمان',
          service: 'نام سامانه',
          subject: 'موضوع',
          date: 'تاریخ ایجاد',
          lastUpdate: 'آخرین به روز رسانی',
          operatorName: 'اپراتور',
          creator: 'ایجاد کننده',
          responder: 'دریافت کننده',
          status: 'وضعیت',
          sendStatus: 'وضعیت ارسال',
          seen: 'مشاهده شده'
        }
      },

      notifications: {
        attachUpload: 'فایل مورد نظر آپلود شد',
        requestSend: 'درخواست شما ارسال شد لطفا منتظر بمانید!',

        insert: {
          success: 'تیکت مورد نظر با موفقیت ایجاد شد',
          error: 'افزودن تیکت با خطا همراه شد'
        },

        sendMessage: {
          success: 'پیام مورد نظر با موفقیت ارسال شد',
          error: 'ارسال پیام مورد نظر با خطا همراه شد'
        },

        changeOperator: {
          success: 'ویرایش اپراتور تیکت با موفقیت انجام شد',
          error: 'ویرایش اپراتور تیکت با خطا همراه شد'
        },

        parseError: {
          service: 'سرویس انتخاب شده معتبر نیست!',
          subject: 'موضوع انتخاب شده معتبر نیست!',
          message: 'متن وارد شده معتبر نیست!',
          attachments: 'پیوست انتخاب شده معتبر نیست!',
          operator: 'اپراتور انتخاب شده معتبر نیست!'
        }
      },

      confirmations: {
        send: {
          title: 'تاییدیه ارسال پیام',
          body: 'آیا از ارسال پیام خود اطمینان دارید؟'
        }
      },

      validators: {
        subject: 'موضوع تیکت به صورت صحیح وارد نشده است!',
        message: 'متن پیام به صورت صحیح وارد نشده است!',
        service: 'سرویس به صورت صحیح انتخاب نشده است!'
      }
    },

    list: {
      title: 'تیکت ها'
    },

    insert: {
      title: 'افزودن تیکت جدید'
    },

    answer: {
      title: 'افزودن پاسخ به تیکت'
    },

    detail: {
      title: 'جزئیات تیکت',

      labels: {
        ticketId: 'تیکت ',
        status: 'وضعیت تیکت: ',
        createdAt: 'زمان ایجاد: ',
        lastUpdate: 'آخرین بروزرسانی: ',
        user: 'کاربر',
        operator: 'اپراتور',
        setComplete: 'مشکلم حل شد'
      }
    }
  },

  // draggable dynamic table
  draggableDynamicTable: {

    filters: 'فیلترها',

    activeFilters: {
      title: 'فیلترهای اعمال شده'
    },

    setting: {
      showColumns: 'نمایش ستون ها'
    },

    notifications: {
      loading: 'در حال بارگزاری اطلاعات ...',
      error: 'دریافت اطلاعات با خطا مواجه شد',
      empty: 'هیچ اطلاعاتی وجود ندارد'
    },

    actions: {
      print: 'پرینت',
      download: 'دریافت',
      setting: 'تنظیمات جدول'
    }
  },

  // date picker
  datePicker: {
    labels: {
      submit: 'تائید',
      cancel: 'انصراف',
      now: 'اکنون',
      nextMonth: 'ماه بعد',
      prevMonth: 'ماه قبل'
    },

    formats: {
      date: 'jYYYY/jMM/jDD',
      dateTime: 'jYYYY/jMM/jDD HH:mm',
      time: 'HH:mm'
    }
  },

  //Button
  create: 'افزودن'
}
